module.exports = __webpack_public_path__ + "img/GYLFW_11.a2bcb607.jpg";